import React from 'react';
export default React.createContext(null);


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/~/react-transition-group/esm/TransitionGroupContext.js
// module id = 610
// module chunks = 121